<template>
  <nav :class="['footer-nav', typeClass, colsClass]">
    <ul class="footer-nav__inner">
      <li v-for="item in items" :key="`nav-item-${item.id}`" class="footer-nav__col">
        <p
          :class="{
            'footer-nav__label': true,
            'is-hide': item.hideTitle,
          }"
        >
          <span class="footer-nav__label-text">{{ item.label }}</span>
        </p>
        <ul class="footer-nav__items">
          <footer-nav-item v-for="child in item.children" :key="`nav-child-${child.id}`" :item="child" />
        </ul>
      </li>
    </ul>
  </nav>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import FooterNavItem from '~/components/ui/layout/footer-nav/FooterNavItem.vue';
import type { LooseObject } from '~/types/generic';

const props = defineProps({
  items: {
    type: Array as () => { id: number; label: string; hideTitle: boolean; children: LooseObject[] }[],
    required: true,
  },
  type: {
    type: String,
    default: 'primary',
  },
});

const typeClass = computed(() => {
  return `is-${props.type}`;
});
const colsClass = computed(() => `is-${props.items.length}-cols`);
</script>
